const style = {
  container: {
    border: `1px solid #666`
  },
  inputWrapper: {
    padding: 0
  },
  input: {
    color: `black`
  },
  button: {
    width: `100%`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/User/Main/style/ColorBlind/search.js